import { handleApiErrors } from '../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { FormInputConfig, AllInputTypes } from '../../../../../../trash/shared/interfaces/form-input-config';
import { FormComponent } from '../../../../../../trash/shared/components/dynamic-form/form/form.component';
import { ErrorOrError } from '../../../../../core/results/error-or/models/error-or-error.model';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { ICreateAccountResponse } from '../../dtos/responses/create-account.response';
import { IUpdateAccountRequest } from '../../dtos/requests/update-account.request';
import { ICreateAccountRequest } from '../../dtos/requests/create-account.request';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AccountsService } from '../../services/accounts.service';
import { Subscription, tap, catchError, finalize } from 'rxjs';
import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { getIdFormConfig } from '../../../../../../views/pages/adminstration/temp-common/utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-create-update-account',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule, DialogModule, ButtonModule, FormsModule, FormComponent, TranslateModule],
    templateUrl: './create-update-account.component.html',
    styleUrl: './create-update-account.component.scss'
})
export class CreateUpdateAccountComponent {
    private subscriptions: Subscription[] = [];

    isLoadingAddEditItem = false;
    form: FormInputConfig[] = [];
    formValues: any = null;
    validationErrors: any = {};
    validationEmit = false;

    constructor(
        private _AccountsService: AccountsService,
        public dataObj: DynamicDialogConfig,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
        private ref: DynamicDialogRef,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        if (this.dataObj?.data?.item) {
            this.formValues = this.dataObj?.data?.item;
        }
        this.initForm();
    }

    // Initialize the form
    initForm() {
        // Initialize with the default configuration
        if (this.formValues?.id) {
            // Only push the `englishName` field if `id` exists
            this.form = [
                getIdFormConfig(this.dataObj?.data?.item?.id),
                {
                    type: AllInputTypes.Text,
                    name: 'englishName',
                    label: this.translate.instant('FORMS.ACCOUNT_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.ACCOUNT_NAME')}`,
                    defaultValue: this.formValues?.englishName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.ACCOUNT_NAME')}` }]
                }
            ];
        } else {
            // Add all fields for creation
            this.form = [
                getIdFormConfig(this.dataObj?.data?.item?.id),
                {
                    type: AllInputTypes.Text,
                    name: 'englishName',
                    label: this.translate.instant('FORMS.ACCOUNT_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.ACCOUNT_NAME')}`,
                    defaultValue: this.formValues?.englishName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.ACCOUNT_NAME')}` }]
                },
                {
                    type: AllInputTypes.Text,
                    name: 'adminFirstName',
                    label: this.translate.instant('FORMS.ADMIN_FIRST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.ADMIN_FIRST_NAME')}`,
                    defaultValue: this.formValues?.adminFirstName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.ADMIN_FIRST_NAME')}` }]
                },
                {
                    type: AllInputTypes.Text,
                    name: 'adminLastName',
                    label: this.translate.instant('FORMS.ADMIN_LAST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.ADMIN_LAST_NAME')}`,
                    defaultValue: this.formValues?.adminLastName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.ADMIN_LAST_NAME')}` }]
                },
                {
                    type: AllInputTypes.Email,
                    name: 'adminEmail',
                    label: this.translate.instant('FORMS.ADMIN_EMAIL'),
                    placeholder: `${this.translate.instant('FORMS.EX')} email@email.com`,
                    defaultValue: this.formValues?.adminEmail,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.ADMIN_EMAIL')}` }]
                }
            ];

            // Conditionally add the password field if `visible` is true
            if (this.dataObj?.data?.visible) {
                this.form.push({
                    type: AllInputTypes.Password,
                    name: 'adminPassword',
                    label: this.translate.instant('FORMS.ADMIN_PASSWORD'),
                    placeholder: `${this.translate.instant('FORMS.EX')} P@ssw0rd`,
                    widthClass: 'col-md-12',
                    defaultValue: this.formValues?.adminPassword,
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.ADMIN_PASSWORD')}` }]
                });
            }
        }
    }
    valueChanged(data: any) {
        this.formValues = { ...data };
    }

    onClose(data?: any) {
        this.ref.close(data);
    }
    emitValidation() {
        this.validationEmit = !this.validationEmit;
        this.cdr.detectChanges();
    }

    async submitForm(data: any) {
        this.isLoadingAddEditItem = true;
        data.isChangePasswordRequired = false;

        // Determine request type
        if (this.formValues?.id) {
            // Handle update request
            const updateData: IUpdateAccountRequest = this.prepareUpdateDataRequest(data);
            const subscription = (await this._AccountsService.update(updateData, this.formValues.id))
                .pipe(
                    tap((res: any) => {
                        // Process response specific to update
                        this.processAddEditResponse(res, true);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingAddEditItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        } else {
            // Handle create request
            const createData: ICreateAccountRequest = this.prepareCreateDataRequest(data);
            const subscription = (await this._AccountsService.create(createData))
                .pipe(
                    tap((res: ICreateAccountResponse) => {
                        // Process response specific to create
                        this.processAddEditResponse(res, false);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingAddEditItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        }
    }
    private prepareCreateDataRequest(data: any): ICreateAccountRequest {
        return {
            name: data?.englishName,
            adminUser: {
                email: data?.adminEmail,
                firstName: data?.adminFirstName,
                lastName: data?.adminLastName,
                password: data?.adminPassword
          },
          accountType: ""
        };
    }

    private prepareUpdateDataRequest(data: any): IUpdateAccountRequest {
        return {
            name: data?.englishName
        };
    }
    private processAddEditResponse(response: void | ICreateAccountResponse, isUpdate: boolean) {
      if (isUpdate) {
        this.toastService.showSuccess(this.translate.instant('GENERAL.SUCCESS'), this.translate.instant('GENERAL.SUCCESSFULLY_UPDATED'));
      } else {
          this.toastService.showSuccess(this.translate.instant('GENERAL.SUCCESS'), this.translate.instant('GENERAL.SUCCESSFULLY_CREATED'));
      }
        this.onClose(response);
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
